import { useState, useRef } from 'react';
import { LS_CHART_BASIS_SIZES } from '../../pages/MainPage/Body';


const top = 40; // header(40)
const RESIZING = 'resizing';
const ACTIVE_CHART_RESIZER = 'chart__resizer--active';

const ChartResizer = () => {
  const [resizing, setResizing] = useState<boolean>(false);
  const handleRef = useRef<any>(null);

  const onStart = (e: any) => {
    e.preventDefault();
    setResizing(true);
    if (handleRef.current) {
      handleRef.current.parentNode.classList.add(RESIZING);
      handleRef.current.classList.add(ACTIVE_CHART_RESIZER);
    }
  };

  const onEnd = (e: any) => {
    e.preventDefault();
    setResizing(false);
    if (handleRef.current) {
      const middleBlockContainer = handleRef.current.parentNode.parentNode;
      const tmp = (e.clientY - top)/middleBlockContainer.clientHeight;
      const data = {
        flex1: tmp * 100,
        flex2: (1 - tmp) * 100
      };
      localStorage.setItem(LS_CHART_BASIS_SIZES, JSON.stringify(data));
      handleRef.current.parentNode.classList.remove(RESIZING);
      handleRef.current.classList.remove(ACTIVE_CHART_RESIZER);
    }
  };

  const onMove = (e: any) => {
    if (resizing) {
      if (handleRef.current) {
        const left_block = handleRef.current.parentNode;
        const chart_container = left_block.children[0];
        const trades_container = left_block.children[2];
        const tmp = (e.clientY - top)/left_block.clientHeight;
        chart_container.style.flexBasis = `${tmp * 100}%`;
        trades_container.style.flexBasis = `${(1 - tmp) * 100}%`;
      }
    }
  };

  return <div
    ref={handleRef}
    className='chart__resizer'
    onMouseUp={onEnd}
    onMouseDown={onStart}
    onMouseMove={onMove}
  />;
};

export default ChartResizer;